import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function PublicBookProfileSum() {
  const [book, setBook] = useState(undefined);
  const { id } = useParams();
  const { REACT_APP_BOOKS } = process.env;



  function localreload() {
    if (id) {
      console.log(REACT_APP_BOOKS);
      fetch(`${REACT_APP_BOOKS}pubbiblioteca/${id}`)
        .then(async (resp) => {
          if (resp.ok) {
            return resp.json();
          } else {
            const error = await resp.json();
            throw new Error(error.message || "Algo ha salido mal");
          }
        })
        .then((resp) => setBook(resp))
        .catch((e) => console.log(e));
    }
  }
  useEffect(() => {
    localreload();
  }, [id]);

  return (
    <>
      {!book ? (
        <div className="w-full h-screen p-6 text-lg font-medium text-gray-600 dark:text-gray-400 dark:bg-gray-900">
          Loading...
        </div>
      ) : (
        <>
          <div class=" flex flex-col justify-center">
            <p class="text-gray-600 text-center font-light lg:px-16">
              {book.abstract}
            </p>
            
          </div>
        </>
      )}
    </>
  );
}
